import React from 'react';
import { connect } from 'react-redux';
import {getLeaderboard, refreshLeaderboard} from '../actions/race';
import LeaderTable from './LeaderTable';
import SidebarWidgets from './SidebarWidgets';

class Leaderboard extends React.Component {

  constructor(props, context) {
    super(props, context);
  }

  state = {
    selectedTab: 'leader',
    autoRefresh: false
  };

  componentDidMount() {
    if (this.props.raceDetail && this.props.raceDetail.race_id) {
      this.props.getLeaderboard();
    }
  }

  componentDidUpdate(oldProps){
    if (this.props.raceDetail && (this.props.raceDetail.race_id !== oldProps.raceDetail.race_id || this.props.eventId !== oldProps.eventId)) {
      this.props.getLeaderboard();
    }
  }

  turnOnRefresh() {
    this.setState({autoRefresh: true});

    const _this = this;
    this.timeout = setInterval(() => {
      _this.props.refreshLeaderboard();
    }, 5000);
  }

  turnOffRefresh() {
    this.setState({autoRefresh: false});

    if (this.timeout) {
      this.timeout.clearInterval();
    }

  }

  render() {

    const {raceDetail} = this.props;

    if (!raceDetail || !raceDetail.name) return null;

    return (
    <div className="flexbox-container">

      {this.props.raceDetail.txt_results && this.props.raceDetail.txt_results[this.props.eventId] ?
        (
          <div className="content">


            <div className="section-leaderboard">
              <div className="section-head">
                <h1 className="section-title" id="section-title" style={{marginTop: '20px'}}>No Leaderboard</h1>
              </div>
            </div>
          </div>
        ) : (
          <div className="content">


            <div className="section-leaderboard">
              <div className="section-head">
                <h1 className="section-title" id="section-title" style={{marginTop: '20px'}}>Leaders</h1>

                <div className="section-actions">
                  Auto Refresh &nbsp;

                  {
                    this.state.autoRefresh ? (
                      <span>On</span>
                    ) : (
                      <a href="javascript:;" className="link-on" onClick={this.turnOnRefresh.bind(this)}>On</a>
                    )
                  }

                  |

                  {
                    this.state.autoRefresh ? (
                      <a href="javascript:;" className="link-off" onClick={this.turnOffRefresh.bind(this)}>Off</a>
                    ) : (
                      <span>Off</span>
                    )
                  }
                </div>
              </div>

              <div className="section-body">
                {this.props.leadersMen && this.props.leadersMen.length > 0 &&
                  <div className="table" id="menTable">
                    <div className="table-head clearfix">
                      <h3 className="table-title hideForSearch" id="menTableTitle">Men </h3>

                      <div className="table-head-actions hideForSearch">
                        <a onClick={this.props.updateTab.bind(this, 'results')} className="link-more" id="more-results-men">All Results</a>
                      </div>
                    </div>

                    <div className="table-body">
                      <LeaderTable leaders={this.props.leadersMen} history={this.props.history} />
                    </div>
                  </div>
                }

                {this.props.leadersWomen && this.props.leadersWomen.length > 0 &&
                  <div className="table" id="womenTable">
                    <div className="table-head clearfix">
                      <h3 className="table-title">Women </h3>

                      <div className="table-head-actions">
                        <a onClick={this.props.updateTab.bind(this, 'results')} className="link-more" id="more-results-women">All Results</a>
                      </div>
                    </div>

                    <div className="table-body">
                      <LeaderTable leaders={this.props.leadersWomen} history={this.props.history} />
                    </div>
                  </div>
                }
              </div>
            </div>
          </div>
        )

      }

      <SidebarWidgets />
    </div>
  );
  }
}

function mapStateToProps(state) {
  return {
    raceDetail: state.rr360.raceDetail,
    leadersMen: state.rr360.leadersMen,
    leadersWomen: state.rr360.leadersWomen,
    eventId: state.rr360.eventId
  };
}


export default connect(mapStateToProps, {getLeaderboard, refreshLeaderboard})(Leaderboard);



// WEBPACK FOOTER //
// ./src/components/Leaderboard.js